import { render } from "./BaseIcon.vue?vue&type=template&id=7c7ae2ae"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/malina/mySpace/work/v-art/protocol/template-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__